import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { AuthService } from '../../../../lib/auth.service';
import { PhoneNumber } from '../../../../models/auth/phone-number';
import { Dispatcher } from '../../dispatcher';
import {
  reauthSuccess,
  resetState,
  showReauthModal,
  storeErrorMessage,
  updateLoading,
} from '../../reauth/reauth.actions';

@Injectable({ providedIn: 'root' })
export class ReauthModalCommands {
  private confirmationResult: firebase.auth.ConfirmationResult | undefined;

  constructor(
    private readonly authService: AuthService,
    private readonly dispatcher: Dispatcher,
  ) {}

  async sendSMS(recaptchaContainer: string) {
    const recaptcha = this.authService.createRecapture(recaptchaContainer);
    const phoneNumber = this.getPhoneNumber();

    try {
      this.confirmationResult = await this.authService.reauthenticateWithPhoneNumber(
        recaptcha,
        phoneNumber,
      );
    } catch (e) {
      this.storeDefaultErrorMessage();
      Sentry.captureException(e);
    }
  }

  async confirmVerificationCode(code: string) {
    this.dispatcher.dispatch(updateLoading(true));

    if (this.confirmationResult === undefined) {
      this.storeDefaultErrorMessage();
      this.dispatcher.dispatch(updateLoading(false));
      return;
    }

    try {
      await this.confirmationResult.confirm(code);
      this.dispatcher.dispatch(reauthSuccess(true));
      this.dispatcher.dispatch(updateLoading(false));
    } catch (e) {
      this.dispatcher.dispatch(storeErrorMessage('番号が違います。'));
      this.dispatcher.dispatch(updateLoading(false));
      Sentry.captureException(e);
    }
  }

  cancel() {
    this.dispatcher.dispatch(showReauthModal(false));
  }

  resetState() {
    this.dispatcher.dispatch(resetState());
  }

  private storeDefaultErrorMessage() {
    this.dispatcher.dispatch(storeErrorMessage('エラーが発生しました。'));
  }

  private getPhoneNumber(): PhoneNumber {
    const user = this.authService.getCurrentUser();
    if (user && user.phoneNumber) {
      return new PhoneNumber(user.phoneNumber);
    } else {
      return new PhoneNumber('');
    }
  }
}
